import React from 'react'
import AsyncCreatableSelect from 'react-select/async-creatable'
import Select from 'react-select'
import useOfferionTranslation from '../store/hooks/useOfferionTranslation'

type Props = {
    loadOptions?: (val: string) => Promise<any>
    placeholder?: string
    createNewLabel?: string
    onChange?: (newValue: any) => void
    onCreateOption?: (inputValue: string) => void
} & {
    selectedOption?: string
    options?: { value: string; label: string }[]
    placeholder?: string
    onChange?: (newValue: any) => void
}

export default function AutocompleteInput({ placeholder = 'Select...', onChange, ...props }: Props) {
    const { t } = useOfferionTranslation()

    if (props.loadOptions) {
        return (
            <AsyncCreatableSelect
                onChange={onChange}
                onCreateOption={props.onCreateOption}
                placeholder={placeholder}
                cacheOptions
                defaultOptions
                autoFocus
                loadingMessage={() => t('Allaround.Message.loading')}
                loadOptions={props.loadOptions}
                className="react-select-container"
                classNamePrefix="react-select"
                formatCreateLabel={
                    props.createNewLabel
                        ? inputValue => (
                              <div className="react-select__create-new-record">
                                  {props.createNewLabel} "{inputValue}"
                              </div>
                          )
                        : undefined
                }
            />
        )
    }

    const val = props.options?.find(p => p.value == props.selectedOption)

    return (
        <Select
            value={val}
            onChange={onChange}
            placeholder={placeholder}
            options={props.options}
            className="react-select-container"
            classNamePrefix="react-select"
        ></Select>
    )
}
